module.exports = __webpack_public_path__ + "img/Badge.dcb6c46b.svg";